import { connect } from 'react-redux';

import Routes from './Routes';
import { selectors } from '../../../dux/user';
import { needsSignUpSteps } from '../../../dux/org/selectors';

const mapStateToProps = (state) => ({
  isAuthenticated: selectors.isAuthenticated(state),
  needsSignUpSteps: needsSignUpSteps(state),
  // Need to mitigate blocked updates: https://github.com/ReactTraining/react-router/blob/master/packages/react-router/docs/guides/blocked-updates.md
  location: state.router.location,
});

export default connect(mapStateToProps, null)(Routes);
